import React, { useState } from "react";
import { Menu, MenuItem, darkScrollbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import config from "environment";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUIStates,
  selectUser,
  setSelectedMenu,
  setSelectedMenuId,
  setUIStates,
} from "../../redux/features/appData/appDataSlice";
import "./AvatarMenu.css";
import "../../css/Icons.css";
import { MENUS } from "../config/menus";
import { iconPath } from "winslow-core";
import { useCoreDataLoader } from "../../hooks/useCoreDataLoader";
import { toastSuccess } from "../../config";
import toast from "react-hot-toast";

const notProd = config.env === "development" || config.env === "staging";

const AVATAR_MENU = {
  LOGOUT: "logout",
  PERSONAL: "personal",
  WORKSPACE: "workspace",
  BILLING: "billing",
  GMAIL: "gmail",
  ADMIN_REFRESH: "admin_refresh",
};

type AvatarMenuProps = {
  image: string;
};

export default function AvatarMenu({ image }: AvatarMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reloadAll } = useCoreDataLoader(true);

  const storeUser = useSelector(selectUser);
  const uiStates = useSelector(selectUIStates);

  const { logout } = useAuth0();

  const closeSnippetSidebar = () => {
    dispatch(
      setUIStates({
        ...uiStates,
        snippetSidebarOpen: false,
        snippetEdited: false,
      })
    );
  };

  const handleAdminRefresh = () => {
    reloadAll(storeUser?.currentWorkspaceId);
    toast("Redux refreshed", toastSuccess);
  };

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // no floaters on avatar menu pages
    dispatch(
      setUIStates({
        ...uiStates,
      })
    );

    // route it
    switch (selection) {
      case AVATAR_MENU.PERSONAL:
        closeSnippetSidebar();
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/waz/settings/personal");
        break;
      case AVATAR_MENU.WORKSPACE:
        closeSnippetSidebar();
        dispatch(setSelectedMenu(MENUS.UNSELECTED));
        dispatch(setSelectedMenuId(undefined));
        navigate("/waz/settings/workspaces");
        break;
      // case AVATAR_MENU.BILLING:
      //   closeSnippetSidebar();
      //   dispatch(setSelectedMenu(MENUS.UNSELECTED));
      //   dispatch(setSelectedMenuId(undefined));
      //   navigate("/billing");
      //   break;
      case AVATAR_MENU.ADMIN_REFRESH:
        handleAdminRefresh();
        break;
      case AVATAR_MENU.LOGOUT:
        navigate("/logout");
        break;
      // case AVATAR_MENU.GMAIL:
      //   navigate("/plugins");
      //   break;
      default:
    }
  };

  console.log("[AvatarMenu] notProd: ", notProd);
  console.log("[AvatarMenu] config: ", config);

  return (
    <>
      <div className="avatar-image-and-name" onClick={handleButtonClick}>
        <div className="avatar-image">
          <img src={image} alt="" />
        </div>
        <div className="avatar-name">
          {storeUser?.firstName} {storeUser?.lastName}
        </div>
        <div className="avatar-caret">
          <img src={iconPath("down.svg", storeUser)} alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.WORKSPACE)}>
          Workspace Settings
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.PERSONAL)}>
          Personal Settings
        </MenuItem>
        {notProd &&
          <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.ADMIN_REFRESH)}>
            Refresh Redux
          </MenuItem>
        }
        {/* <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.BILLING)}>
          Upgrade and Billing
        </MenuItem>
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.GMAIL)}>
          Gmail Plugin
        </MenuItem> */}
        <MenuItem onClick={() => handleMenuSelection(AVATAR_MENU.LOGOUT)}>
          <span style={{ color: "var(--text-color-error)" }}>Log Out</span>
        </MenuItem>
      </Menu>
    </>
  );
}
